import payload_plugin_qLmFnukI99 from "/app/anybill-partner-portal-v3/node_modules/@pinia/nuxt/dist/runtime/payload-plugin.js";
import jsonify_LXSbrlp2oZ from "/app/anybill-partner-portal-v3/plugins/jsonify.ts";
import revive_payload_client_4sVQNw7RlN from "/app/anybill-partner-portal-v3/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/anybill-partner-portal-v3/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/anybill-partner-portal-v3/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/app/anybill-partner-portal-v3/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/app/anybill-partner-portal-v3/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/anybill-partner-portal-v3/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/app/anybill-partner-portal-v3/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/app/anybill-partner-portal-v3/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/app/anybill-partner-portal-v3/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/anybill-partner-portal-v3/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import switch_locale_path_ssr_5csfIgkrBP from "/app/anybill-partner-portal-v3/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/app/anybill-partner-portal-v3/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import logger_kEXgbufg9p from "/app/anybill-partner-portal-v3/plugins/logger.ts";
import plugin_AUP22rrBAc from "/app/anybill-partner-portal-v3/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.js";
import api_GFfDXud5Cr from "/app/anybill-partner-portal-v3/plugins/api.ts";
import error_handler_kEP5FliEXj from "/app/anybill-partner-portal-v3/plugins/error-handler.ts";
import vuetify_7h9QAQEssH from "/app/anybill-partner-portal-v3/plugins/vuetify.ts";
export default [
  payload_plugin_qLmFnukI99,
  jsonify_LXSbrlp2oZ,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  logger_kEXgbufg9p,
  plugin_AUP22rrBAc,
  api_GFfDXud5Cr,
  error_handler_kEP5FliEXj,
  vuetify_7h9QAQEssH
]